// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"37d1e889","605":"2fb8da04","809":"62452d41","981":"5a38119a"}[chunkId] + ".chunk.js";
};